/* index.tsx generated by @compiled/babel-plugin v0.38.1 */
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./index.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
/* eslint-disable @atlassian/tangerine/import/no-parent-imports */

import { useIntl } from 'react-intl-next';
import { di } from 'react-magnetic-di';
import { Link, useRouter } from 'react-resource-router';
import { ButtonItem, CustomItem, LinkItem, MenuGroup, Section } from '@atlaskit/menu';
import { useHubContext } from '@atlassian/company-hub-common';
import { AccountDetails } from '../account-details';
import messages from './messages';
import { getStudioEditorUrl } from './utils';
var styles = {
  menu: "_1bsbnpok"
};
export var AvatarMenu = function AvatarMenu() {
  var hubContext = useHubContext();
  var _useRouter = useRouter(),
    _useRouter2 = _slicedToArray(_useRouter, 1),
    match = _useRouter2[0].match;
  var user = hubContext.user,
    env = hubContext.env,
    actions = hubContext.actions;
  var isJiraAdmin = user.isJiraAdmin;
  var cloudId = env.cloudId,
    helpCenterId = env.helpCenterId;
  var pageId = match.params.id;
  var onLogoutClick = actions.onLogoutClick;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  return /*#__PURE__*/React.createElement("div", {
    className: ax([styles.menu])
  }, /*#__PURE__*/React.createElement(MenuGroup, {
    spacing: "cozy"
  }, /*#__PURE__*/React.createElement(Section, null, /*#__PURE__*/React.createElement(AccountDetails, null)), isJiraAdmin && /*#__PURE__*/React.createElement(Section, {
    hasSeparator: true
  }, /*#__PURE__*/React.createElement(LinkItem, {
    href: getStudioEditorUrl(helpCenterId, cloudId || '', pageId)
  }, formatMessage(messages.editSite))), /*#__PURE__*/React.createElement(Section, {
    hasSeparator: true
  }, /*#__PURE__*/React.createElement(CustomItem, {
    component: Link,
    to: "/user/profile"
  }, formatMessage(messages.profile)), /*#__PURE__*/React.createElement(ButtonItem, {
    onClick: onLogoutClick
  }, formatMessage(messages.logout)))));
};